import React from 'react';
import LanguageSwitcher from './LanguageSwitcher';
import ThemeSwitcher from './ThemeSwitcher';

export default function FloatingLanguageSwitcher() {
    return (
        <div className="hidden md:block fixed bottom-4 right-4 z-40 pointer-events-none">
            <div className="pointer-events-auto neon-panel px-2 py-1.5 shadow-neon flex items-center gap-2">
                <LanguageSwitcher variant="dropdown-up-md" />
                <span className="w-px h-5 bg-cyber-border/60" />
                <ThemeSwitcher placement="top" size="md" />
            </div>
        </div>
    );
}
